export default __webpack_public_path__ + "static/media/logo.fdc79193.png";